/**
 * useOnboarding
 *
 * Reads onboarding status from Clerk publicMetadata.
 * Backend sets `publicMetadata.onboardingComplete = true` via the Clerk Admin API
 * after the user completes the onboarding flow.
 *
 * Returns:
 *   - isLoaded:           Clerk SDK has resolved the user session
 *   - onboardingComplete: true once the backend has confirmed completion
 */
import { useUser } from '@clerk/clerk-react';

export interface OnboardingState {
  isLoaded: boolean;
  onboardingComplete: boolean;
}

export function useOnboarding(): OnboardingState {
  const { isLoaded, user } = useUser();

  if (!isLoaded || !user) {
    return { isLoaded: false, onboardingComplete: false };
  }

  const meta = user.publicMetadata as Record<string, unknown> | null | undefined;
  return {
    isLoaded: true,
    onboardingComplete: meta?.onboardingComplete === true,
  };
}
